import styled from "styled-components";
import { withContentWrap } from "../../../themes/mixins";

/**
 * Page gutter used by every landing section: 1280px of content with
 * 80px side margins at 1440px, narrowing down to 20px at 390px.
 */
export const Container = styled.div`
  ${withContentWrap()};
`;

export default Container;
